const slug = import.meta.env.VITE_BOOQABLE_COMPANY_SLUG || 'tradewinds-mechanical-llc';

export const BOOQABLE_COMPANY_SLUG = slug;
export const BOOQABLE_ADMIN_URL = `https://${slug}.booqable.com`;
export const BOOQABLE_API_URL = `${BOOQABLE_ADMIN_URL}/api/4`;
